import enLang from "./entries/en-US";
import frLang from "./entries/fr-FR";

const AppLocale = {
  en: enLang,
  fr: frLang
};

export default AppLocale;
